module.exports = __webpack_public_path__ + "img/undraw_checklist__re_2w7v.df0c4a9b.svg";